<template>
  <div>
    <b-card class="col-8" border-variant="light" bg-variant="light">
      <b><u>Sync History:</u></b>
      <b-container fluid>
        <b-table
          show-empty
          stacked="md"
          id="scistarterHistoryTable"
          ref="scistarterHistoryTable"
          :items="scistarterHistory"
          :fields="visibleFields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :empty-text="emptyText"
          :sort-icon-left="true">

          <template v-slot:cell(createdAt)="row">
            <DateTime :date="row.item.createdAt" :dateTime="false"></DateTime>
          </template>
          <template v-slot:cell(options)="row">
            <div class="options-holder right">
              <b-btn v-if="row.item.status !== 'completed' && row.item.status !== 'failed'"
                     @click="onClickRefresh()"
                     class="mt-1 mr-1 my-1"
                     alt="Refresh Status"
                     title="Refresh Status">
                <font-awesome-icon icon="sync"/>&nbsp;&nbsp;&nbsp;Refresh
              </b-btn>
            </div>
          </template>
          <template #table-busy>
            <small>Fetching Transfer History...</small>
            <i class="fa fa fa-spin fa-spinner ml-2"></i>
          </template>
        </b-table>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import DateTime from "../../../../components/common/date-time/DateTime.vue";

export default {
  components: {DateTime},

  data() {
    return {
      history: [],
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      sortBy: "createdAt",
      sortDesc: true,
      sortDirection: "desc",
      emptyText: "No Data Yet!",

      fieldList: [
        {
          key: 'createdAt', label: 'Created Date', sortable: true, class: "text-left", visible: true,
        },
        {
          key: 'syncType', label: 'Sync Type', sortable: true, class: "text-left", visible: true,
          formatter: (val) => {
            return val === 'project on' ? 'Sync Turned On' : 'Sync Turned Off';
          },
        },
        {
          key: 'status', label: 'Status', sortable: false, class: "text-center", visible: true,
          formatter: (val) => {
            return val.charAt(0).toUpperCase() + val.slice(1);
          },
        },
        {key: 'duration', label: 'Sync Time (seconds)', sortable: false, class: "text-center", visible: false,},
        {key: "options", label: "Options", class: "text-right", visible: true,},
      ],

    }
  },

  mounted() {
    this.$root.$on('refreshHistory', data => {
      this.onClickRefresh()
    });
  },

  computed: {
    ...mapGetters({
      project: "project/get/project",
    }),

    visibleFields() {
      // Property returns only the fields where visible = true
      return this.fieldList.filter(field => field.visible)
    },
  },

  methods: {
    ...mapActions({
      getSciStarterHistory: "integration_scistarter/getSciStarterHistory",
    }),

    onClickRefresh() {
      this.$refs.scistarterHistoryTable.refresh();
    },

    scistarterHistory(ctx) {
      this.isBusy = true;
      let urlParams = `${this.urlBuilder(ctx)}` + '&itemsPerPage=2';
      const data = {projectId: this.project.id, urlParams};

      return this.getSciStarterHistory(data).then((data) => {
        this.totalItems = data["hydra:totalItems"];
        this.currentPage = ctx.currentPage || 1;
        this.sortBy = ctx.sortBy || "";
        this.isBusy = false;

        this.history = data["hydra:member"].map(item => {
          return {
            ...item,
          }
        })
        return this.history
      });

    },
  },

};
</script>

<style lang="scss">

</style>
